import { inject, Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Observable, of } from 'rxjs';
import { IFeature } from '@shared/components/interfaces/feature.interface';
import { AppConstants } from '@core/constants';
import { FeatureManagementService } from '@shared/services/feature-management/feature-management.service';
import { FeatureSlugEnum } from '@shared/enums/feature-slug.enum';
import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { FeatureFlagValue } from '@shared/services/feature-flags/interfaces/feature-flags.interface';
import { WaffleFeatureFlagsService } from '@shared/services/feature-flags/waffle-feature-flags.service';
import { SessionService } from '@core/services/session.service';

@Injectable()
export class MyInscydService {
  private apiService: ApiService = inject(ApiService);
  private featureManagementService: FeatureManagementService = inject(FeatureManagementService);
  private sessionService = inject(SessionService);
  public featureFlagsService: WaffleFeatureFlagsService = inject(WaffleFeatureFlagsService);

  private hardCodedSettingTileList: IFeature[];

  public getMyInscydFeatureList(): Observable<IFeature[]> {
    return this.apiService.get(AppConstants.API.MY_INSCYD_FEATURE_ITEM.GET);
  }

  public getHardCodedSettingTileList(): Observable<IFeature[]> {
    const auth: Record<string, any> = JSON.parse(this.sessionService.getCookie('auth') || '{}');
    const date_joined = auth.date_joined;

    // TODO: Remove this when we retire the old reports
    // NOTE: Hardcoded switch over for customer joining after 1st April 2026
    const hideCustomPdfTextTile = date_joined != null ? date_joined > '2026-04-01T00:00:00Z' : false;
    this.hardCodedSettingTileList = [
      {
        urlNavigateTo: '/home/administration/training-zone-template',
        id: 0,
        category_name: 'Apps',
        tags: ['Apps'],
        image:
          'https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/training_zone_builder/Training+Zone+Builder.png',
        is_published: true,
        category: 5,
        name: 'Training Zone Builder',
        is_recommended: false,
        marketing_features: [],
        dependencies: [],
        description_html: {},
        created_at: '',
        description: 'Create custom training zones to target specific training adaptations',
        discounts: [],
        is_delete: false,
        is_enabled: this.featureManagementService.getFeatureValue(FeatureSlugEnum.TRAINING_ZONE_BUILDER),
        links: [],
        slug: '',
        suggested_courses: [],
        summary: 'Training Zone Building',
        updated_at: '',
        waitlist: true,
        buttonName: 'set up',
      },
      {
        urlNavigateTo: '/home/custom-pdf-text',
        id: 0,
        category_name: 'Customization',
        tags: ['Deprecated'],
        image: 'https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/pdf_report_texts/Custom+PDF+Text.png',
        is_published: true,
        category: 5,
        name: '[Legacy] PDF Report Texts',
        is_recommended: false,
        marketing_features: [],
        dependencies: [],
        description_html: {},
        created_at: '',
        description:
          'Create your own texts to show up on the PDF reports. NOTE: These customizations do not apply to our new, highly customizable, page-based report generator.',
        discounts: [],
        is_delete: false,
        is_enabled: !hideCustomPdfTextTile,
        links: [],
        slug: '',
        suggested_courses: [],
        summary: 'Training Zone Building',
        updated_at: '',
        waitlist: true,
        buttonName: 'Customize',
      },
      {
        urlNavigateTo: '/home/custom-athlete-category',
        id: 0,
        category_name: 'Customization',
        tags: ['Beta'],
        image:
          'https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/custom_athlete_categories/Athlete+Category.png',
        is_published: true,
        category: 0,
        name: 'Athlete categories & grading',
        is_recommended: false,
        marketing_features: [],
        dependencies: [],
        description_html: {},
        created_at: '',
        description:
          'Create custom categories for different group of athletes and set up custom grading system to be used in the dashboards',
        discounts: [],
        is_delete: false,
        is_enabled: this.featureManagementService.getFeatureValue(FeatureSlugEnum.CUSTOM_ATHLETE_CATEGORIES),
        links: [],
        slug: '',
        suggested_courses: [],
        summary: 'Custom Athlete Category',
        updated_at: '',
        waitlist: true,
        buttonName: 'Customize',
      },
      {
        urlNavigateTo: '/home/metric-settings',
        id: 0,
        category_name: 'Customization',
        tags: ['Settings'],
        image: 'https://inscyd-prod-public.s3.eu-central-2.amazonaws.com/features/metric_settings.png',
        is_published: true,
        category: 0,
        name: 'Metric Settings',
        is_recommended: false,
        marketing_features: [],
        dependencies: [],
        description_html: {},
        created_at: '',
        description: 'Configure how you want specific physiological benchmarks to be calculated',
        discounts: [],
        is_delete: false,
        is_enabled: this.featureFlagsService.getValue(FeatureFlagEnum.GERMAN_FEDERATION),
        links: [],
        slug: '',
        suggested_courses: [],
        summary: 'Metric Settings',
        updated_at: '',
        waitlist: true,
        buttonName: 'Customize',
      },
    ];

    return of(this.hardCodedSettingTileList.filter((tile: IFeature) => tile.is_enabled));
  }
}
